import {
  ADD_ROUTE,
  ADD_COST,
  ADD_HOME,
  DELETE_ROUTE,
  LOAD_ROUTES,
  SUBTRACT_COST,
  SUBTRACT_HOME,
  ACTIVE_ROUTE,
  DEACTIVE_ROUTE,
  CLEAR_TABLE,
  CONTROL_COLLAPSE,
  ADD_BUSINESS,
  SUBTRACT_BUSINESS,
  EXCLUDED_BUSINESS,
  HOVERED_ROUTE,
  UNHOVERED_ROUTE,
  RESET_SELECTED_ROUTES
} from '../actions-types';
export const addRoute = (route) => {
  return {
    type: ADD_ROUTE,
    payload: route
  };
};
export const deleteRoute = (index) => {
  return {
    type: DELETE_ROUTE,
    payload: index
  };
};
export const loadRoutesList = (routes) => {
  return {
    type: LOAD_ROUTES,
    payload: routes
  };
};

export const addCost = (cost) => {
  return {
    type: ADD_COST,
    payload: cost
  };
};

export const subtractCost = (cost) => {
  return {
    type: SUBTRACT_COST,
    payload: cost
  };
};

export const addHomes = (home) => {
  return {
    type: ADD_HOME,
    payload: home
  };
};
export const subtractHome = (home) => {
  return {
    type: SUBTRACT_HOME,
    payload: home
  };
};

export const activeRoute = (index) => {
  return {
    type: ACTIVE_ROUTE,
    payload: index
  };
};
export const deactiveRoute = (index) => {
  return {
    type: DEACTIVE_ROUTE,
    payload: index
  };
};

export const clearTable = () => {
  return {
    type: CLEAR_TABLE
  };
};
export const controlCollapse = () => {
  return {
    type: CONTROL_COLLAPSE
  };
};
export const addBusiness = (business) => {
  return {
    type: ADD_BUSINESS,
    payload: business
  };
};

export const subtractBusiness = (business) => {
  return {
    type: SUBTRACT_BUSINESS,
    payload: business
  };
};

export const excludedBusiness = () => {
  return {
    type: EXCLUDED_BUSINESS
  };
};

export const hoveredRoute = (route) => {
  return {
    type: HOVERED_ROUTE,
    payload: route
  };
};

export const unhoveredRoute = () => {
  return {
    type: UNHOVERED_ROUTE
  };
};

export const resetSelectedRoutes = () => {
  return {
    type: RESET_SELECTED_ROUTES
  };
};
